import { Route } from '@angular/router';
import { DocumentationComponent } from './components/documentation/documentation.component';

export const appRoutes: Route[] = [
  {
    path: ':docSlug/:chapterSlug/:childSlug',
    component: DocumentationComponent,
  },
  {
    path: ':docSlug/:chapterSlug',
    component: DocumentationComponent,
  },
  {
    path: ':docSlug',
    component: DocumentationComponent,
  },
  {
    path: '**',
    redirectTo: 'vendedores',
    pathMatch: 'full',
  },
];
